/**
 * 移动端跳转分时图函数
 * 
 * 根据当前环境自动选择合适的跳转方式：
 * - 在同花顺/iFind/期货客户端中，使用客户端协议跳转到分时图
 * - 在其他环境中，不执行任何操作并输出警告
 * 
 * @param code 股票或合约代码
 * @param market 市场代码
 * @returns void
 */
import { isInThsApp } from '../../base/env/app/isInThsApp';
import { isInIFindApp } from '../../base/env/app/isInIFindApp';
import { isInFuturesApp } from '../../base/env/app/isInFuturesApp';

/**
 * 移动端跳转分时图
 * 
 * @param code 股票或合约代码
 * @param market 市场代码
 */
export function jumpFenshi(code: string, market: string): void {
  if (!code || !market) {
    console.warn('股票代码或市场代码无效');
    return;
  }

  // 检查是否在客户端环境
  if (isInThsApp() || isInIFindApp() || isInFuturesApp()) {
    // 根据不同客户端选择不同的 webid
    const webid = isInFuturesApp() ? '2351' : '2205';
    
    // 构建跳转 URL
    const url = `client.html?action=ymtz^webid=${webid}^stockcode=${code}^marketid=${market}`;
    
    // 执行跳转
    window.location.href = url;
  } else {
    // 非客户端环境，输出警告
    console.warn('当前环境不支持跳转分时图');
  }
} 